import React from "react";
import { useState,useEffect } from "react";
import { GetBookPages } from "../API";

export default function Books(props, { value = "", onChange }) {
  const [pageNumber, setPageNumber] = useState(1);

  const [pagesCount, setPagesCount] = useState(0)
  useEffect(() => {
    GetBookPages(props.match.params.crsnum).then(messageData => {
       setPagesCount(messageData);
    });
  }, [props.match.params.crsnum]);
  function updateInputPageNumber(event) {
    setPageNumber(parseInt(event.target.value));
    if (typeof onChange === "function") {
      onChange(event.target.value);
    }
  }
  return (
    <div class="card text-center border-0 m-t-20">
      <div class="card-header f-w-600">
        <div class="row">
          <div class="col-4"></div>
          <div class="col-4">
            <div class="input-group">
              <div class="input-group-prepend">
                <button
                  class="btn btn-primary"
                  type="button"
                  onClick={() => setPageNumber(pageNumber - 1)}
                >
                  <i class="fas fa-lg fa-fw m-r-5 fa-arrow-circle-left"></i>
                  Previous
                </button>
              </div>
              <input
                type="number"
                class="form-control"
                value={pageNumber}
                onChange={updateInputPageNumber}
              />

              <div class="input-group-append">
                <span class="input-group-addon" id="basic-addon2">
                  /{pagesCount}
                </span>
                <button
                  class="btn btn-primary"
                  type="button"
                  onClick={() => setPageNumber(pageNumber + 1)}
                >
                  Next
                  <i class="fas fa-lg fa-fw m-l-5 fa-arrow-circle-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card-body">
        <img
          alt=""
          src={`api/General/Book/${props.match.params.crsnum}/${pageNumber}`}
        />
      </div>
      <div class="card-footer f-w-600">
        <strong>{pageNumber}</strong>/ {pagesCount}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/course/Books/Books.js